import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import QuizLayout from "./Shared/QuizLayout";
import Question from "./Shared/Question";
import ResultCard from "./Shared/ResultCard";

export default function BusinessQuiz() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [questionQueue, setQuestionQueue] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // 質問データの読み込み
  useEffect(() => {
    async function fetchQuestions() {
      const snapshot = await getDocs(collection(db, "business_questions"));
      const fetched = snapshot.docs.map((doc) => doc.data());
      const sorted = fetched.sort((a, b) => a.id.localeCompare(b.id));
      const initial = sorted.filter((q) => q.id.startsWith("business_0") && q.id <= "business_06");

      console.log("✅ 全質問データ取得:", sorted.map(q => q.id));
      setQuestions(sorted);
      setQuestionQueue(initial);
    }
    fetchQuestions();
  }, []);

  // 回答処理（分岐含む）
  function handleAnswer(selectedOption) {
    const currentQuestion = questionQueue[currentIndex];
    console.log(`🟢 質問 ${currentQuestion.id} に対して選んだ選択肢:`, selectedOption);

    // business_06 の分岐処理
    if (currentQuestion.id === "business_06") {
      const redirectId = currentQuestion.redirects[selectedOption.index].redirect;
      const redirectQ = questions.find((q) => q.id === redirectId);
      if (redirectQ) {
        const newQueue = [...questionQueue];
        newQueue.splice(currentIndex + 1, 0, redirectQ);
        console.log(`🔀 分岐：${redirectId} を index ${currentIndex + 1} に挿入`);
        setQuestionQueue(newQueue);
      } else {
        console.warn(`⚠️ 分岐先 ${redirectId} が見つかりません`);
      }
      setAnswers([...answers, selectedOption.scores]);
      setCurrentIndex(currentIndex + 1);
      return;
    }

    // 通常質問処理
    setAnswers([...answers, selectedOption.scores]);

    if (currentIndex + 1 < questionQueue.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      handleSubmit([...answers, selectedOption.scores]);
    }
  }

  // 診断結果の集計と表示
  async function handleSubmit(allScores) {
    setLoading(true);

    const scoreMap = {};
    allScores.forEach((scoreObj) => {
      Object.entries(scoreObj).forEach(([key, val]) => {
        if (key === "score") return;
        if (!scoreMap[key]) scoreMap[key] = {};
        scoreMap[key][val] = (scoreMap[key][val] || 0) + (scoreObj.score || 1);
      });
    });

    console.log("📊 集計されたスコアマップ:", scoreMap);

    const gameSnap = await getDocs(collection(db, "games"));
    const allGames = gameSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    const scoredGames = allGames.map((game) => {
      let score = 0;
      Object.entries(scoreMap).forEach(([key, tagScores]) => {
        const gameVal = game[key];
        if (!gameVal) return;
        if (Array.isArray(gameVal)) {
          gameVal.forEach((val) => {
            if (tagScores[val]) score += tagScores[val];
          });
        } else {
          if (tagScores[gameVal]) score += tagScores[gameVal];
        }
      });
      console.log(`🎮 ${game.name || game.id} の合計スコア:`, score);
      return { ...game, matchScore: score };
    });

    const sorted = scoredGames.sort((a, b) => b.matchScore - a.matchScore);
    const bestScore = sorted[0]?.matchScore || 0;
    const topGames = sorted.filter((g) => g.matchScore === bestScore && bestScore > 0);
    const selected = topGames.slice(0, 3);

    console.log("🏆 診断結果として選ばれたゲーム:", selected.map(g => g.name || g.id));
    setResults(selected);
    setLoading(false);
  }

  function handleRetry() {
    navigate("/");
  }

  // ローディング中表示
  if (loading) return <p>診断結果を計算中です…</p>;

  // 結果表示
  if (results.length > 0) {
    return (
      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">あなたにぴったりのボードゲーム</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {results.map((game) => (
            <ResultCard key={game.id} game={game} />
          ))}
        </div>
        <button
          className="mt-6 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          onClick={handleRetry}
        >
          もう一度診断する
        </button>
      </div>
    );
  }

  // 質問表示
  if (questionQueue.length === 0) return <p>質問を読み込み中です...</p>;

  return (
    <QuizLayout
      currentIndex={currentIndex}
      total={questionQueue.length}
      onBack={() =>
        currentIndex === 0 ? navigate("/") : setCurrentIndex(currentIndex - 1)
      }
    >
      <Question
        question={questionQueue[currentIndex]}
        onAnswer={handleAnswer}
        selectedTags={{}} // 使ってないけど構造維持
        type="business"
      />
    </QuizLayout>
  );
}
